angular.module('app.collegeCommitments.collegeCommitmentsList', [])
  .factory('app.collegeCommitments.collegeCommitmentsList', [
    '$http',
    function ($http) {
      let commits;

      return commits = {
        players: null,
        loading: false,
        error: null,
        retrieve: function () {
          commits.loading = true;
          return $http.get(window.location.api('college_commitments'))
            .then(
              (response) => {
                let data = response.data ? response.data.results : {};

                if (data.players) {
                  commits.players = data.players;
                }
                if (data.error) {
                  commits.error = data.error;
                }
                return commits.loading = false;
              },
              () => {
                if (data.error) {
                  commits.error = data.error;
                }
                return commits.loading = false;
              }
            );
        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/collegeCommitments/collegeCommitmentsService.js